import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import { IOrdersData } from 'models/orders/orders';
import { IOrderListItem } from 'models/orders/order';
import { INotificationsAction, INotificationsData } from 'models/notifications/notifications';

/** Action Types */
export const REQUEST_START: string = 'userfeed/REQUEST_START';
export const REQUEST_FAILURE: string = 'userfeed/REQUEST_FAILURE';
export const GET_SUCCESS: string = 'userfeed/GET_SUCCESS';
export const RESET_DATA: string = 'userfeed/RESET_DATA';
export const SET_ITEMS_PAGE: string = 'userfeed/SET_ITEMS_PAGE';
export const SET_ISFIRSTLOAD: string = 'userfeed/SET_ISFIRSTLOAD';
export const LIKE_ITEM_SUCCESS: string = 'userfeed/LIKE_ITEM_SUCCESS';
export const LIKE_REQUEST_START: string = 'userfeed/LIKE_REQUEST_START';
export const LIKE_REQUEST_FAILURE: string = 'userfeed/LIKE_REQUEST_FAILURE';

/** Initial State */
const initialState: INotificationsData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	isFirstLoad: false,
};

/** Reducer */
export function userFeedReducer(state = initialState, action: INotificationsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		case LIKE_REQUEST_START:
			return Object.assign({}, state, {
				isFetchingLikes: true,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetchingLikes: false,
			});

		case LIKE_REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetchingLikes: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getUserFeedItems(isFirstLoad: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetUserFeedData());
			dispatch(setUserFeedIsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().userFeed.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().userFeed.itemsPage.itemsPerPage;

		let queryString = '?';
		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/HomePageFeed' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						if (isFirstLoad) {
							dispatch(resetUserFeedData());
						}
						const userFeedState: IOrdersData = getState().userFeed;
						const items: IOrderListItem[] = userFeedState.items;
						const newItems: IOrderListItem[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getUserFeedItemsSuccess(items));
						dispatch(setUserFeedItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): INotificationsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getUserFeedItemsSuccess(items: any[]): INotificationsAction {
	return {
		type: GET_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): INotificationsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function resetUserFeedData(): INotificationsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setUserFeedItemsPage(itemsPage: IPage): INotificationsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

export function setUserFeedIsFirstLoad(isFirstLoad: boolean): INotificationsAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}

/** Action Creator */
export function userFeedLikeItemSuccess(): INotificationsAction {
	return {
		type: LIKE_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function userFeedLikeRequestStart(): INotificationsAction {
	return {
		type: LIKE_REQUEST_START,
	};
}

/** Action Creator */
export function userFeedLikeRequestFailure(message: any): INotificationsAction {
	return {
		type: LIKE_REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}
